<form
  class="opportunity-milestone-entry-body"
  [formGroup]="formGroup"
  [ngClass]="{ 'opportunity-milestone-entry-done': readonly }"
>
  <div
    class="opportunity-milestone-entry-top"
    [ngClass]="{
      'opportunity-milestone-entry-done': isDone() || readonly,
      'opportunity-milestone-entry-active': isActive() && !readonly,
    }"
  >
    <span>{{ title }}</span>
  </div>
  <div
    class="opportunity-milestone-entry-center"
    [ngClass]="{ 'opportunity-milestone-entry-done': isDone() || readonly }"
  >
    <div>
      {{ description }}
    </div>
    <div *ngIf="isNboApproval" class="divestment-entry-center-selector">
      <mat-form-field class="divestment-entry-center-selector-width">
        <mat-label>Type of NBO</mat-label>
        <mat-select formControlName="nboApproval" [disabled]="isNotAvailable() || readonly">
          <mat-select-trigger>
            {{ nboApprovalToLabel[formGroup.value.nboApproval] }}
            <mat-icon
              class="tooltip-icon"
              svgIcon="tooltip"
              [matTooltip]="nboApprovalToTooltip[formGroup.value.boApproval]"
            ></mat-icon>
          </mat-select-trigger>
          <mat-option *ngFor="let val of allNboApprovalOptions" [value]="val">
            {{ nboApprovalToLabel[val] }}
            <mat-icon class="tooltip-icon" svgIcon="tooltip" [matTooltip]="nboApprovalToTooltip[val]"></mat-icon>
          </mat-option>
        </mat-select>
        <mat-error>Mandatory</mat-error>
      </mat-form-field>
    </div>
    <div *ngIf="isBoApproval" class="divestment-entry-center-selector">
      <mat-form-field class="divestment-entry-center-selector-width">
        <mat-label>Type of BO</mat-label>
        <mat-select formControlName="boApproval" [disabled]="isNotAvailable() || readonly">
          <mat-select-trigger>
            {{ boApprovalToLabel[formGroup.value.boApproval] }}
            <mat-icon
              class="tooltip-icon"
              svgIcon="tooltip"
              [matTooltip]="boApprovalToTooltip[formGroup.value.boApproval]"
            ></mat-icon>
          </mat-select-trigger>
          <mat-option *ngFor="let val of allBoApprovalOptions" [value]="val">
            {{ boApprovalToLabel[val] }}
            <mat-icon class="tooltip-icon" svgIcon="tooltip" [matTooltip]="boApprovalToTooltip[val]"></mat-icon>
          </mat-option>
        </mat-select>
        <mat-error>Mandatory</mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="opportunity-milestone-entry-bottom" [ngClass]="{ 'opportunity-milestone-entry-done': readonly }">
    <div class="opportunity-milestone-entry-checkboxes">
      <div class="opportunity-milestone-entry-bottom-column">
        <span
          class="opportunity-milestone-entry-bottom-label"
          [ngClass]="{ 'opportunity-milestone-entry-bottom-label-changed': isNotAvailableDirty() }"
        >
          NA
        </span>
        <digires-checkbox
          [formGroup]="formGroup"
          [formCtrlName]="getFormControlNameNa()"
          [disabled]="isComplete() || readonly"
          (onChange)="emitEvent()"
        ></digires-checkbox>
      </div>

      <div class="opportunity-milestone-entry-bottom-column">
        <span
          class="opportunity-milestone-entry-bottom-label"
          [ngClass]="{ 'opportunity-milestone-entry-bottom-label-changed': isCompleteDirty() }"
        >
          Complete
        </span>
        <digires-checkbox
          [formGroup]="formGroup"
          [formCtrlName]="getFormControlNameComplete()"
          tooltipPosition="below"
          tooltip="{{ getCompleteCheckboxReadOnlyReason() }}"
          [disabled]="isNotAvailable() || readonly || hasNoDate()"
          (onChange)="emitEvent()"
        ></digires-checkbox>
      </div>
    </div>

    <!--TODO: Kay to implement Angular v15 datepicker-->
    <mat-form-field
      [ngClass]="{
        'opportunity-milestone-entry-date-hidden': isNotAvailable(),
      }"
    >
      <mat-label>{{ getPlaceholderDate() }}</mat-label>
      <label>
        <input
          matInput
          type="date"
          formControlName="{{ getFormControlNameDate() }}"
          [readonly]="isDone() || readonly"
        />
      </label>
      <mat-error *ngIf="formGroup.get(getFormControlNameDate())?.invalid">
        {{ ValidatorUtil.getErrorMessage(formGroup.get(getFormControlNameDate())) }}
      </mat-error>
    </mat-form-field>

    <div *ngIf="!isPlausibilityWarning()" class="warning-triangle"></div>
    <mat-icon *ngIf="isPlausibilityWarning()" class="warning-triangle" [matTooltip]="getPlausibilityWarningTooltip()">
      warning
    </mat-icon>
  </div>
</form>
